<main
  class="h-screen bg-cover flex items-center justify-center"
  style="background-image: url('../../assets/images/background.svg')"
>
  <router-outlet />
</main>
